var React = require('react');

function Coin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.5,0A7.5,7.5,0,1,0,15,7.5,7.509,7.509,0,0,0,7.5,0Zm0,14.013A6.513,6.513,0,1,1,14.013,7.5,6.52,6.52,0,0,1,7.5,14.013Z","fill":"#e8de61","key":0}),React.createElement("path",{"d":"M74.974,32.895V30.046a1.372,1.372,0,0,1,.66.561.453.453,0,0,0,.651.143.523.523,0,0,0,.134-.695A2.291,2.291,0,0,0,74.974,29v-.8a.471.471,0,1,0-.94,0V29a2.485,2.485,0,0,0,0,4.792v2.849a1.372,1.372,0,0,1-.66-.561.452.452,0,0,0-.651-.143.523.523,0,0,0-.134.695,2.291,2.291,0,0,0,1.445,1.05v.8a.471.471,0,1,0,.94,0v-.8a2.485,2.485,0,0,0,0-4.792Zm-1.825-1.5a1.444,1.444,0,0,1,.884-1.353v2.706A1.444,1.444,0,0,1,73.149,31.4Zm1.825,5.244V33.938a1.477,1.477,0,0,1,0,2.706Z","transform":"translate(-67.004 -25.845)","fill":"#e8de61","key":1})]);
}

Coin.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Coin;

Coin.default = Coin;
